<template>
  
  <a-layout-content style="margin: 16px">
    <div>
      <div
        :style="{
          padding: '24px',
          margin: '24px 16px 24px 16px',
          background: '#fff',
          minHeight: '100px',
        }"
      >
        <a-form-model
          ref="ruleForm"
          layout="inline"
          :model="formInline"
          @submit="handleSubmitQuery"
          @submit.native.prevent
        >

          <a-form-model-item label="门店选择">
            <a-select
              v-model="formInline.shopId"
              placeholder="请选择门店"
              style="width: 250px"
              allowClear
            >
              <a-select-option
                v-for="item in storeList"
                :key="item.storeId"
                :value="item.storeId"
              >
                {{ item.storeName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" html-type="submit"> 条件查询 </a-button>
            <a-button style="margin-left: 10px" @click="resetForm">
              重置
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>

    <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
      <a-button
        type="primary"
        :style="{ margin: '0 0 24px 0' }"
        v-on:click="showModal"
      >
        新增
      </a-button>
      <a-button type="danger" :style="{ margin: '0 0 24px 0' }" @click="dels">
      批量删除
    </a-button>
      <a-modal
        v-model="visible"
        title="添加分类"
        @ok="handleOk"
        cancelText="取消"
        okText="确定"
      >
        <a-form-model
          :model="formInline"
          @submit="handleSubmit"
          @submit.native.prevent
        >
          <a-form-model-item label="分类名称">
            <a-input
              v-model="formInline.categoryName"
              placeholder="请输入分类名称"
            >
            </a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal
        v-model="visibletwo"
        title="添加分类"
        @ok="handleOktwo"
        cancelText="取消"
        okText="确定"
      >
        <a-form-model
          :model="formInline"
          @submit="handleSubmit"
          @submit.native.prevent
        >
          <a-form-model-item label="分类名称">
            <a-input
              v-model="formInlinetwo.categoryNametwo"
              placeholder="请输入分类名称"
            >
            </a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        :row-key="(item) => item.objId"
        :row-selection="rowSelection"
        @change="handleTableChange"
        size="middle"
      >
        <!-- <template slot="categoryName" slot-scope="categoryName">
          {{ categoryName }} 
        </template>
         <template slot="categoryName" slot-scope="categoryName">
          {{ categoryName }} 
        </template> -->
        <template slot="operate" slot-scope="text, operate">
          <!-- <a href="javascript:;" @click="editbtn(operate)">编辑</a> -->
          <a href="javascript:;" @click="delbtn(operate)">删除</a>
        </template>
      </a-table>
    </div>
  </a-layout-content>
</template>
<script>
import {
  storeClassification,
  storeClassificationEdit,
  storeClassificationAdd,
  storeClassificationDel,
  storeClassificationDels,
  getStoreList
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "门店名称",
    dataIndex: "storeName",
    sorter: true,
    scopedSlots: { customRender: "storeName" },
  },
  {
    title: "项目名称",
    dataIndex: "projectName",
    sorter: true,
    scopedSlots: { customRender: "projectName" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    sorter: true,
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      updateId: null,
      formInline: {
        shopId: null,
        categoryName: "",
        page: 1,
        limit: 10,
      },
      formInlinetwo: {
        categoryNametwo: "", // 输入的分类名称
        sortNumtwo: "", // 输入的显示数据
      },
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      visible: false,
      visibletwo: false,
      storeList: [],
    };
  },
  mounted() {
    this.getStoreClassification();
    this.getstoresData();
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setidList", selectedRowKeys);
          console.log(`selectedRowKeys: ${selectedRowKeys}`);
          console.log(`selectedRows: ${selectedRows}`);
        },
      };
    },
  },
  methods: {
     getstoresData() {
      getStoreList().then((res) => {
        if(res.data){
          this.storeList = res.data;
        }
      });
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storeClassification({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          console.log(res);
          this.loading = false;
        }
      );
      this.loading = false;
    },
    getStoreClassification() {
      this.formInline = {
        shopId: null,
        categoryName: "",
        page: 1,
        limit: 10,
      };
      storeClassification({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        message.success(res.msg);
      });
    },
    // 删除
    delbtn(row) {
      this.$confirm({
        title: '确认删除',
        content: `删除项目名称，可能影响已有的门票套餐，请确保没有对应的项目套餐`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.loading = true;
          storeClassificationDel(row.objId).then((res) => {
            this.loading = false;
            this.getStoreClassification();
            message.success(res.data);
          });
        },
        onCancel: () => {
          console.log('取消删除');
        },
      });
    },
     // 批量删除
    dels() {
      let idList = this.$store.state.idList;
      if (!idList || idList.length === 0) {
        message.warning("请先选择要删除的数据");
        return;
      }
      this.$confirm({
        title: '确认删除',
        content: `删除项目名称，可能影响已有的门票套餐，请确保没有对应的项目套餐`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
            this.loading = true;
            storeClassificationDels(idList).then((res) => {
              this.loading = false;
              this.getStoreClassification();
              message.success(res.data);
            }).catch(() => {
              this.loading = false;
            });
          },
        onCancel: () => {
          console.log('取消删除');
        }
      });
    },
    // 编辑
    // editbtn(row) {
    //   console.log(row);
    //   this.updateId = row.objId;
    //   this.visibletwo = true;
    //   this.formInlinetwo.categoryNametwo = row.projectName;
    // },
    handleSubmit() {},

    handleSubmitQuery(){
      storeClassification({
        shopId: this.formInline.shopId,
        limit: 10, 
        page: 1
      }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        message.success(res.msg);
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      // 添加
      storeClassificationAdd({
        projectName: this.formInline.categoryName,
      }).then((res) => {
        this.getStoreClassification();
        message.success(res.data);
      });
      this.formInline = {
        shopId: null,
        categoryName: "",
        page: 1,
        limit: 10,
      }
      this.visible = false;
    },
    
    // handleOktwo() {
    //   storeClassificationEdit({
    //     projectName: this.formInlinetwo.categoryNametwo,
    //     id: this.updateId,
    //   }).then((res) => {
    //     this.getStoreClassification();
    //     message.success(res.data);
    //   });
    //   this.formInlinetwo = {
    //     categoryNametwo: "", // 输入的分类名称
    //   };
    //   this.visibletwo = false;
    // },

    resetForm() {
      this.formInline = {
        shopId: null,
        categoryName: "",
        page: 1,
        limit: 10,
      };
      this.getStoreClassification();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/storeManagement/storeClassificationTwo/storeClassificationThree.vue